import * as React from 'react';
import { Theme, withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const styles = (theme: Theme) => createStyles({
  faqItem: {
    paddingTop: '1.5em',
    paddingLeft: '0.75em',
    paddingRight: '0.75em',
    '&:first-child': {
      paddingLeft: 0
    },
    '&:last-child': {
      paddingRight: 0
    },
    '& > div:first-child': {
      fontSize: '1.25em',
      fontStyle: 'italic',
      fontWeight: 600,
      letterSpacing: '0.0355em',
      lineHeight: 1.4,
      marginBottom: '0.8em'
    }
  }
});

interface FaqItemProps {
  title: string;
  content: string;
}

const FaqItem: React.SFC<WithStyles & FaqItemProps> = ({
  classes,
  title,
  content
}) => {
  return (
    <Grid item sm={12} md={4} container direction="column" className={classes.faqItem}>
      <Grid item>{title}</Grid>
      <Grid item>{content}</Grid>
    </Grid>
  );
}

export default withStyles(styles)(FaqItem);



// WEBPACK FOOTER //
// ./src/landingPage/components/FaqItem.tsx